var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / MN") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D246",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CE2F",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-MN",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy",
    fill: "#146BBC",
    mask: "url(#mask-2)",
    x: 9.33333333,
    y: 0,
    width: 9.33333333,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#E43642",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 9.33333333,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#E43642",
    mask: "url(#mask-2)",
    x: 18.6666667,
    y: 0,
    width: 9.33333333,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66666667,12 L6.66666667,16 L5.33333333,16 L5.33333333,12 L6.66666667,12 Z M4,12 L4,16 L2.66666667,16 L2.66666667,12 L4,12 Z M5.33333333,14.6666667 L4.66666667,16 L4,14.6666667 L5.33333333,14.6666667 Z M4.66666667,13.3333333 C5.0348565,13.3333333 5.33333333,13.6318102 5.33333333,14 C5.33333333,14.3681898 5.0348565,14.6666667 4.66666667,14.6666667 C4.29847683,14.6666667 4,14.3681898 4,14 C4,13.6318102 4.29847683,13.3333333 4.66666667,13.3333333 Z M5.33333333,12 L4.66666667,13.3333333 L4,12 L5.33333333,12 Z M4.66666667,10.6666667 C5.0348565,10.6666667 5.33333333,10.9651435 5.33333333,11.3333333 C5.33333333,11.7015232 5.0348565,12 4.66666667,12 C4.29847683,12 4,11.7015232 4,11.3333333 C4,10.9651435 4.29847683,10.6666667 4.66666667,10.6666667 Z M4.66666667,10 L5.33333333,10.6666667 L4,10.6666667 L4.66666667,10 Z",
    id: "Rectangle-1611",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMn);
export default __webpack_public_path__ + "static/media/MN.daacc85ff0cf1cc7bf6343df5bf89dd7.svg";
export { ForwardRef as ReactComponent };